import React from 'react';
import EmotionalRegulation2023 from 'views/EmotionalRegulation2023';

const LifeSkillPage = () => {
  return <EmotionalRegulation2023/>;
};

export default LifeSkillPage;
